import { useCallback, useMemo } from 'react'

import get from 'lodash/get'

import type { EditorValue } from '../state/types'
import { useSalesEditor } from './use-sales-editor'

interface Options<T extends EditorValue> {
  name: string
  originalValue: T
  dateRange: string
}

export const useCustomizableValue = <T extends EditorValue>({
  name,
  originalValue,
  dateRange,
}: Options<T>) => {
  const { activeTemplate, setChanges, currentChanges } = useSalesEditor()

  const value = useMemo<T>(() => {
    const path = `${dateRange}.${name}`

    return (get(currentChanges, path) ??
      get(activeTemplate?.data, path) ??
      originalValue) as T
  }, [currentChanges, activeTemplate, name, originalValue, dateRange])

  const onChange = useCallback(
    (newValue: T) => {
      setChanges(dateRange, name, newValue)
    },
    [name, setChanges, dateRange],
  )

  return {
    value,
    onChange,
  }
}
